import { EVA_RESEARCH_NAME } from "constants/app.constants";

import { UserDataSourcePreferenceCategory } from "api/dataSource";

export const MidstreamSources: UserDataSourcePreferenceCategory[] = [
  {
    category: "Volumetrics",
    dataSources: [
      {
        dataSourceName: EVA_RESEARCH_NAME,
        isActive: true,
        order: 1,
        source: ""
      }
    ]
  },
  {
    category: "HeaderData",
    dataSources: [
      {
        dataSourceName: EVA_RESEARCH_NAME,
        isActive: true,
        order: 1,
        source: ""
      }
    ]
  }
];
